import { Typography, Tooltip } from 'seagull';
import styles from "./CustomXAxisTick.module.scss";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const chevronWidth = 4;

// eslint-disable-next-line @typescript-eslint/no-explicit-any

export default function CustomXAxisTick(props) {
  const {
    index,
    visibleTicksCount,
    x,
    y,
    payload,
    width,
    tickWidth = 90,
    tickHeight = 60,
    addChevron,
    testid,
    getText,
    getTooltip
  } = props;
  const step = width / (visibleTicksCount * 2);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("foreignObject", {
      x: x - tickWidth / 2,
      y: y,
      width: tickWidth,
      height: tickHeight,
      children: /*#__PURE__*/_jsx("div", {
        xmlns: 'http://www.w3.org/1999/xhtml',
        className: styles.tick,
        children: /*#__PURE__*/_jsx(Tooltip, {
          title: getTooltip ? getTooltip(payload.value) : '',
          placement: "top",
          disableArrow: true,
          children: /*#__PURE__*/_jsx(Typography, {
            variant: "paragraph3",
            skin: "secondary",
            "data-testid": testid && "".concat(testid, "-").concat(payload.value),
            children: getText ? getText(props) : payload.value
          })
        })
      })
    }), addChevron && index < visibleTicksCount - 1 && /*#__PURE__*/_jsx("path", {
      transform: "translate(".concat(x + step - chevronWidth / 2, ",").concat(y - 3 + tickHeight / 2, ")"),
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M.63 7.43c0-.14.04-.27.13-.37L3.3 4 .85.93a.57.57 0 0 1 .08-.8c.25-.2.6-.16.8.08L4.5 3.64c.17.21.17.52 0 .73L1.64 7.79a.57.57 0 0 1-.8.08.57.57 0 0 1-.21-.44Z",
      fill: "#D4D4E0"
    })]
  });
}